EmailFormTextInputView = require('./text_input_view')
GrouponValidate = require('../../../../../groupon/frontend/validate')

class EmailFormPhoneNumberInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .phone_number_input': 'checkPhoneNumber'

  initialize:  ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".phone_number_input"
    @errorElementID = '.validatePhoneNumberInput'
    @template = {phone_input_template: true}

  isInputValid: (hideErrorMsg)->
    phoneNumber = @getInputHtmlElement().val()
    isValidPhoneNumber = true
    if phoneNumber !=""
      isValidPhoneNumber = if window.isUS()
        GrouponValidate.phone phoneNumber
      else
        GrouponValidate.phoneInternational phoneNumber
      if isValidPhoneNumber
        @$el.find(@errorElementID).css('display','none')
        $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border')
      else if !hideErrorMsg
        @$el.find(@errorElementID).css('display','block')
        $('.call-back-phone-number-input').addClass('call-back-inputs-error-border')
    return isValidPhoneNumber

  checkPhoneNumber: ->
    @isInputValid(true)
    @validateEmailForm()

  populateInput:(data)->
    if @isInputGiven()
      data.user_given_phone = @readInput()
      EmailFormTextInputView::populateInput.apply(this, arguments)

module.exports = EmailFormPhoneNumberInputView
